<template>
  <div class="record-time" id="recordtitle">
    <!-- <sidebar @event="formChild"></sidebar> -->
    <div class="topview">
      <span class="top">充电记录</span>
    </div>
    <div class="lowerview">
      <div class="centerview">
        <el-row>
          <el-col :span="21">
            <!-- <div class="selectleftview"> -->
            <ul>
              <li>
                <el-select
                  style="width: 120px"
                  v-model="province_value"
                  clearable
                  placeholder="请选择省份"
                  @change="getcitys(province_value)"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.province"
                    :label="item.province"
                    :value="item.province"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-select
                  v-model="city_value"
                  clearable
                  style="width: 120px"
                  placeholder="请选择城市"
                  @change="getStations(city_value)"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.city"
                    :label="item.city"
                    :value="item.city"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-select
                  v-model="station_value"
                  clearable
                  style="width: 120px"
                  placeholder="请选择场站"
                  @change="getchargers(station_value)"
                >
                  <el-option
                    v-for="item in stationList"
                    :key="item.station_id"
                    :label="item.station_name"
                    :value="item.station_id"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-select
                  v-model="charger_value"
                  clearable
                  multiple
                  style="width: 250px"
                  collapse-tags
                  placeholder="请选择充电桩"
                >
                  <el-option
                    v-for="item in chargerlist"
                    :key="item.charger_id"
                    :label="item.charger_name"
                    :value="item.charger_id"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-date-picker
                  v-model="statrttime_value"
                  type="datetime"
                  style="width: 200px"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择开始时间"
                ></el-date-picker>
              </li>
              <li>
                <el-date-picker
                  v-model="endtime_value"
                  type="datetime"
                  placeholder="请选择结束时间"
                  style="width: 200px"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </li>

              <li>
                <el-select
                  v-model="ChStatus_value"
                  clearable
                  style="width: 160px"
                  placeholder="请选择订单状态"
                >
                  <el-option
                    v-for="item in ChStatuslist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-select
                  v-model="Chtype_value"
                  clearable
                  style="width: 160px"
                  placeholder="请选择结算类型"
                >
                  <el-option
                    v-for="item in Chtypelist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>

              <li class="allkeyword">
                <el-input
                  placeholder="全局搜索(订单号、VIN码、会员名、openID、车牌号、集团ID)"
                  v-model="VipName_input"
                  clearable
                ></el-input>
              </li>
              <li class="phone">
                <el-input
                  placeholder="搜索(用户手机号)"
                  v-model="Phone_input"
                  clearable
                ></el-input>
              </li>
            </ul>
          </el-col>
          <el-col :span="3">
            <!-- <div class="centerrightview"> -->
            <ul>
              <li>
                <el-button
                  type="primary"
                  class="querybutton search"
                  @click="querybtnClick()"
                  >查询</el-button
                >
              </li>
              <li>
                <el-button
                  type="primary"
                  class="exportbutton"
                  @click="exportbtnClick()"
                  :disabled="exportPrivilege == 1"
                  :class="[exportPrivilege == 1 ? 'active' : '']"
                  >导出</el-button
                >
              </li>
            </ul>
            <!-- </div> -->
          </el-col>
        </el-row>
      </div>
      <div class="bottomviewtwo">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%"
        >
          <el-table-column
            align="left"
            prop="station_name"
            label="场站"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="charger_name"
            :show-overflow-tooltip="true"
            label="充电桩"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="nickname"
            label="会员"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="left"
            prop="gun_no"
            label="枪号"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="plate_number"
            label="车牌号"
          ></el-table-column>
          <el-table-column align="left" prop="customer_id" label="客户类型">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.customer_id == '' || scope.row.customer_id == null
                "
                >普通用户</span
              >
              <span v-else>集团客户</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="start_time"
            label="开始时间"
            width="140"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="end_time"
            label="结束时间"
            width="140"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="charge_time"
            label="充电时长"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="total_power"
            label="总充电电量"
          ></el-table-column>

          <el-table-column align="left" prop="elce_fee" label="消费总金额">
            <template slot-scope="scope">
              <span>￥{{ scope.row.elce_fee }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="elce_fee_discount"
            label="折后总金额"
          >
            <template slot-scope="scope">
              <span>￥{{ scope.row.elce_fee_discount }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" prop="customer_status" label="结算类型">
            <template slot-scope="scope">
              <span v-if="scope.row.customer_status == '1'">月结</span>
              <span
                v-else-if="
                  scope.row.customer_status == '2' ||
                  scope.row.customer_status == null
                "
                >即时结算</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" prop="status" label="状态">
            <template slot-scope="scope">
              <span class="btn btn01" v-if="scope.row.status == '1'"
                >充电中</span
              >
              <span class="btn btn02" v-else-if="scope.row.status == '2'"
                >未支付</span
              >
              <span class="btn btn03" v-else-if="scope.row.status == '3'"
                >已完成</span
              >
              <span class="btn btn04" v-else-if="scope.row.status == '4'"
                >异常</span
              >
              <span class="btn btn05" v-else-if="scope.row.status == '5'"
                >其他</span
              >
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                @click="opendia(scope.row.id)"
                style="color: #0071bd; cursor: pointer"
                >详情</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="cutpagesview">
        <el-pagination
          class="pageinclass"
          background
          :page-size="pagesize"
          :page-count="pagecount"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="prev, pager, next,jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 弹框 -->
    <el-dialog  :visible.sync="dialogVisible">
      <div>
        <p>订单号：</p>
        <span>{{ tabData.batch }}</span>
      </div>
      <!-- 场站信息 -->
      <div>
        <p>场站信息</p>
        <el-table
          style="width: 100%"
          border
          :data="stationInfo"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
          <el-table-column
            prop="station_name"
            label="场站"
            width="180"
          ></el-table-column>
          <el-table-column prop="charger_name" label="充电桩">
          </el-table-column>
          <el-table-column prop="gun_no" label="枪号"> </el-table-column>
          <el-table-column prop="charge_time" label="充电时长">
          </el-table-column>
          <el-table-column prop="serv_fee" label="总充电服务费">
          </el-table-column>
          <el-table-column prop="total_power_fee" label="总充电电费">
          </el-table-column>
          <el-table-column prop="elce_fee" label="消费总金额">
          </el-table-column>
          <el-table-column prop="elce_fee_discount" label="折后总金额">
          </el-table-column>
        </el-table>
      </div>
      <!-- 客户信息 -->
      <div>
        <p>客户信息</p>
        <el-table
          style="width: 100%"
          border
          :data="customInfo"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
          <el-table-column prop="nickname" label="会员" width="200">
          </el-table-column>
          <el-table-column prop="customer_id" label="客户类型" width="100">
          </el-table-column>
          <el-table-column prop="jtid" label="集团ID" width="100">
          </el-table-column>
          <el-table-column prop="balance" label="账户余额" width="100">
          </el-table-column>
          <el-table-column prop="openid" label="openID"> </el-table-column>
          <el-table-column prop="plate_number" label="车牌号" width="120">
          </el-table-column>
          <el-table-column prop="vin" label="VIN码" width="160">
          </el-table-column>
        </el-table>
      </div>
      <!-- 充电明细 -->
      <div>
        <p>充电明细</p>
        <el-table
          style="width: 100%"
          border
          :data="payInfo"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
          <el-table-column prop="start_time" label="开始时间" width="140">
          </el-table-column>
          <el-table-column prop="end_time" label="结束时间" width="140">
          </el-table-column>
          <el-table-column prop="total_power" label="总充电电量">
          </el-table-column>
          <el-table-column prop="status" label="状态"> </el-table-column>
          <el-table-column prop="charge_source" label="充电方式">
          </el-table-column>
          <el-table-column prop="batch_s" label="是否正常"> </el-table-column>
          <el-table-column prop="record_source" label="结束原因">
          </el-table-column>
          <el-table-column prop="pay_type" label="结算类型"> </el-table-column>
        </el-table>
      </div>
      <!-- 消费明细 -->
      <div>
        <p>消费明细</p>
        <el-table
          style="width: 100%"
          border
          :data="xiaofei"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
            <el-table-column prop="before_balance" label="账户余额(扣款前)"> </el-table-column>
            <el-table-column prop="before_voucher" label="抵扣券余额(扣款前)"> </el-table-column>
            <el-table-column prop="elce_fee_balance" label="余额扣款"> </el-table-column>
            <el-table-column prop="elce_fee_voucher" label="抵扣券扣款"> </el-table-column>
            <el-table-column prop="after_balance" label="账户余额(扣款后)"> </el-table-column>
            <el-table-column prop="after_voucher" label="抵扣券余额(扣款后)"> </el-table-column>
        </el-table>
      </div>
      <!-- 预付信息 -->
      <div v-if="wwshow">
        <p>预付信息</p>
        <el-table
          style="width: 100%"
          border
          :data="yufu"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
          <el-table-column prop="request_num" label="预付订单号">
            <template slot-scope="scope">{{ scope.row.request_num | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column prop="pre_amount" label="预付金额">
            <template slot-scope="scope">{{ scope.row.pre_amount | defaultValFilter }}</template>
          </el-table-column>
           <el-table-column prop="refund_money" label="退还金额">
            <template slot-scope="scope">{{ scope.row.refund_money | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column prop="pre_status" label="订单状态">
            <template slot-scope="scope">{{ scope.row.pre_status | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column prop="pre_paytime" label="预付时间">
            <template slot-scope="scope">{{ scope.row.pre_paytime | defaultValFilter }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 费率明细 -->
      <div>
        <p>费率明细</p>
        <el-table
          style="width: 100%"
          border
          :data="rateInfo"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        >
          <el-table-column prop="start_charge" label="开始交易电量">
          </el-table-column>
          <el-table-column prop="end_charge" label="结束交易电量">
          </el-table-column>
          <el-table-column prop="power1" label="费率1充电电量">
          </el-table-column>
          <el-table-column prop="power2" label="费率2充电电量">
          </el-table-column>
          <el-table-column prop="power3" label="费率3充电电量">
          </el-table-column>
          <el-table-column prop="power4" label="费率4充电电量">
          </el-table-column>
          <el-table-column prop="amount1" label="费率1充电金额">
          </el-table-column>
          <el-table-column prop="amount2" label="费率2充电金额">
          </el-table-column>
          <el-table-column prop="amount3" label="费率3充电金额">
          </el-table-column>
          <el-table-column prop="amount4" label="费率4充电金额">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { transformStringTime } from "../../filters/index.js";
import { constants } from "fs";
import sidebar from "../sidebar";
import API_ROOT from "../../../config/dev.env";
export default {
  data() {
    return {
      wwshow: true,
      restaurants: [],
      tabData: {},
      stationInfo: [],
      customInfo: [],
      payInfo: [],
      yufu: [],
      rateInfo: [],
      xiaofei:[],
      dialogVisible: false,
      clientWidth: "",
      linkurl: "", //下载链接
      total: 10, //这个是总共有多少条数据
      pagesize: 10, //每页显示条目个数
      currentPage: 1, //当前页数
      pagecount: 10, //页码按钮的数量
      hackReset: true,
      normal: "正常结算",
      nonormal: "异常结算",
      screenWidth: "100",
      province_value: "", //选择省份
      city_value: "", //选择城市
      provinceList: [], //省份列表
      cityList: [], //城市列表
      stationList: [], //场站列表
      chargerlist: [], //充电桩列表
      station_value: "", //选择场站
      charger_value: "", //选择充电桩
      statrttime_value: "", //选择开始时间
      endtime_value: "", //选择结束时间
      batch_input: "", //输入订单号
      VIN_input: "", //输入vin码
      VipName_input: "", //会员昵称
      Phone_input: "", //用户手机号码
      ChStatus_value: "", //选择充电状态
      Chtype_value: "", //选择结算类型
      ChWay_value: "", //选择充电方式

      ChStatuslist: [
        {
          value: 1,
          label: "充电中",
        },
        {
          value: 2,
          label: "未支付",
        },
        {
          value: 3,
          label: "已完成",
        },
      ],
      Chtypelist: [
        {
          value: "1",
          label: "月结",
        },
        {
          value: 2,
          label: "即时结算",
        },
      ],
      ChWaylist: [
        {
          value: 1,
          label: "手机扫码",
        },
        {
          value: 2,
          label: "充电码",
        },
        {
          value: 3,
          label: "VIN码充电",
        },
        {
          value: 4,
          label: "离线启动",
        },
        {
          value: 5,
          label: "其他",
        },
      ],
      tableData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.start_date || time.getTime() > Date.now()
          );
        },
      },
      exportPrivilege: 1, //导出
    };
  },
  beforeRouteEnter(to, from, next) {
    window.document
      .querySelector("body")
      .setAttribute("style", "background-color:#f8f8f8");
    window.document
      .querySelector("body")
      .setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },

  mounted() {
    let role = [];
    role = this.$store.state.role;
    for (let i in role) {
      if (role[i].view_name == "充电管理") {
        for (let j in role[i].chlid) {
          if (role[i].chlid[j].view_name == "充电记录") {
            for (let m in role[i].chlid[j].method) {
              if (role[i].chlid[j].method[m].method_name == "导出") {
                this.exportPrivilege = 0;
              }
            }
          }
        }
      }
    }

    this.$nextTick(function () {
      this.defaultTime();
      this.getprovinces();
      this.querybtnClick();
    });
  },

  methods: {
    defaultTime() {
      // var timestamp = new Date().getTime(); //毫秒
      // timestamp = timestamp - 1 * 24 * 3600 * 1000;
      var d = new Date();

      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth() + 1) +
        "-" +
        this.checkTime(d.getDate()) +
        " 00:00:00";

      this.statrttime_value = start_date;

      this.start_date = start_date;

      var d1 = new Date();
      let end_date = d1.getFullYear() + "-" + this.checkTime(d1.getMonth() + 1) + "-" + this.checkTime(d1.getDate()) + " " + this.checkTime(d1.getHours()) + ":" + this.checkTime(d1.getMinutes()) + ":" + this.checkTime(d1.getSeconds());

      this.endtime_value = end_date;
    },
    /**
     * 导出调用方法
     */
    createAndDownloadFile(content) {
      let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content =
        contentArr[0] +
        "/" +
        contentArr[1] +
        "/" +
        contentArr[2] +
        "/" +
        contentArr[3];

      link.href = content;
      link.click();
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.currentPage = val;
      var value = String(val);
      this.querybtnClick(value);
    },
    /**
     * 获取省份数据列表
     */
    getprovinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provinceList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取城市列表
     */
    getcitys(province_value) {
      this.city_value = "";
      this.cityList = [];
      this.stationList = [];
      this.station_value = "";
      this.charger_value = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province_value,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    /**
     * 获取场站列表
     */
    getStations(city_value) {
      this.station_value = "";
      this.stationList = [];
      this.charger_value = "";
      this.chargerlist = [];

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city_value,
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 300) {
            // 登录态过期;
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            //数据库出错,查询失败
            this.$message.warning(su.data.message);
          } else if (su.data.code == 303) {
            //暂时没有场站数据
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    /**
     * 获取充电桩
     */
    getchargers(station_value) {
      this.charger_value = [];
      this.chargerlist = [];

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: station_value,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeRecord/get_chargers",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.chargerlist = su.data.data;
          } else if (su.data.code == 300) {
            //登录状态已过期，请重新登录
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            this.$message.warning("查询充电桩信息失败");
          } else if (su.data.code == 303) {
            //暂时没有该场站充电桩数据
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    /**
     * 获取筛选信息列表
     */
    querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      if (page != "" && page != null) {
        params.page = page;
      }
      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      if (this.station_value != "") {
        params.station_id = this.station_value;
      }
      if (this.charger_value != "") {
        params.charger_id = this.charger_value;
      }
      if (this.statrttime_value != "" && this.statrttime_value != null) {
        params.start_time = this.statrttime_value;
        params.end_time = this.endtime_value;
      }

      if (this.VipName_input != "") {
        params.keyword = this.VipName_input;
      }

      if (this.Phone_input != "") {
        params.phone = this.Phone_input;
      }

      if (this.ChStatus_value != "") {
        params.status = this.ChStatus_value;
      }
      if (this.Chtype_value != "") {
        params.pay_type = this.Chtype_value;
      }

      if (this.statrttime_value > this.endtime_value) {
        this.$message.warning("结束日期时间不能小于开始日期时间");
      } else {
        this.$api({
          method: "post",
          url: "/api.php/ChargeRecord/get_charge_record",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            if (su.data.code == 1) {
              let datalist = su.data.data;
              for (var i = 0; i < datalist.length; i++) {
                datalist[i].charge_time = transformStringTime(
                  datalist[i].charge_time
                );
              }

              this.tableData = datalist;

              if (page == "" || page == null) {
                this.currentPage = 1;
                this.total = parseInt(su.data._count);
                this.pagecount = su.data.page_count;
              } else {
              }
            } else if (su.data.code == 300) {
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            } else if (su.data.code == 302) {
              //数据库出错查询失败
              this.$message.warning("查询失败");
            } else if (su.data.code == 303) {
              this.total = 0;
              this.pagecount = 1;
              //查询月份不能横跨超过一个月
              this.$message.error("查询月份不能横跨超过一个月");
            } else if (su.data.code == 304) {
              this.total = 0;
              this.pagecount = 1;
              this.$message.warning("未查询到所需记录");
              //暂无所需记录
            }
          })
          .catch((err) => {});
      }
    },
    /**
     * 合计单页数据
     */
     getSummaries(param){
         //columns 是所有列的一个数组
         const {columns,data}=param;
         const sums=[];
         columns.forEach((column,index) => {
             if(index === 0){
               sums[index] = '合计';
               return;
             }

             const values=data.map(item=>Number(item[column.property]));

             if(column.property ==="total_power" ||
                column.property ==="elce_fee" ||
                column.property ==="elce_fee_discount" 
             ){
                 if (!values.every(value =>isNaN(value))){                      
                   sums[index]= values.reduce((prev,curr)=>{
                      const value =Number(curr);
                      if(!isNaN(value)){
                        return prev+curr;
                      }else{
                        return prev;
                      }
                   },0); 
                   
                   sums[index]=sums[index].toFixed(2);
                 }    
             }
         });

         return sums;
     },
    /**
     * 导出数据csv
     */
    exportbtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };

      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      if (this.station_value != "") {
        params.station_id = this.station_value;
        var stationname = "";
        for (var i = 0; i < this.stationList.length; i++) {
          if (this.stationList[i].station_id == this.station_value) {
            stationname = this.stationList[i].station_name;
          }
        }
        params.station_name = stationname;
      }
      if (this.charger_value != "") {
        params.charger_id = this.charger_value;
        var chargerName = "";
        this.chargerlist.map((item) => {
          if (item.charger_id == this.charger_value) {
            chargerName = item.charger_name;
          }
        });
        params.charger_name = chargerName;
      }
      if (this.statrttime_value != "" && this.statrttime_value != null) {
        var d = new Date(this.statrttime_value);

        let start_date = d.getFullYear() + "-" + this.checkTime(d.getMonth() + 1) + "-" + this.checkTime(d.getDate()) + " " + this.checkTime(d.getHours()) + ":" + this.checkTime(d.getMinutes()) + ":" + this.checkTime(d.getSeconds());
        // //最后显示yyyy-MM-dd hh:mm:ss
        // params.start_date = start_date.slice(0, 10);
        params.start_time = start_date;
      }
      if (this.endtime_value != "" && this.endtime_value != null) {
        var d1 = new Date(this.endtime_value);
        let end_date = d1.getFullYear() + "-" + this.checkTime(d1.getMonth() + 1) + "-" + this.checkTime(d1.getDate()) + " " + this.checkTime(d1.getHours()) + ":" + this.checkTime(d1.getMinutes()) + ":" + this.checkTime(d1.getSeconds());
        // //最后显示yyyy-MM-dd hh:mm:ss
        // params.end_date = end_date.slice(0, 10);
        params.end_time = end_date;
      }

      if (this.ChStatus_value != "") {
        params.status = this.ChStatus_value;
      }
      if (this.Chtype_value != "") {
        params.pay_type = this.Chtype_value;
      }
      if (this.VipName_input != "") {
        params.keyword = this.VipName_input;
      }

      this.$api({
        method: "post",
        url: "/api.php/ChargeRecord/explode_records",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.linkurl = su.data.url;
            this.createAndDownloadFile(su.data.url);
          } else if (su.data.code == 300) {
            //登录过期
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            //数据库出错,导出失败
            this.$message.warning("导出失败");
          } else if (su.data.code == 303) {
            //查询月份不能横跨超过1个月
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            //没有可导出记录
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    opendia(id) {
      this.stationInfo = [];
      this.customInfo = [];
      this.payInfo = [];
      this.rateInfo = [];
      this.yufu = [];
      this.xiaofei=[]
      this.dialogVisible = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getRecordDetail",
        id: id,
      };
      this.$api({
        method: "POST",
        url: "/api.php/ChargeRecord/get_record_detail",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
       
          this.tabData = res.data.data;
          if (res.data.data.pay_type == 1) {
            res.data.data.pay_type = "月结";
          } else {
            res.data.data.pay_type = "即时结算";
          }

          if (res.data.data.status == 1) {
            res.data.data.status = "充电中";
          } else if (res.data.data.status == 2) {
            res.data.data.status = "未支付";
          } else if (res.data.data.status == 3) {
            res.data.data.status = "已完成";
          } else if (res.data.data.status == 4) {
            res.data.data.status = "异常";
          } else if (res.data.data.status == 5) {
            res.data.data.status = "其他";
          }

          if (res.data.data.batch_s == 0) {
            res.data.data.batch_s = "正常结算";
          } else {
            res.data.data.batch_s = "非正常结算";
          }

          if (res.data.data.charge_source == 1) {
            res.data.data.charge_source = "手机扫码";
          } else if (res.data.data.charge_source == 2) {
            res.data.data.charge_source = "充电码";
          } else if (res.data.data.charge_source == 3) {
            res.data.data.charge_source = "VIN码充电";
          } else if (res.data.data.charge_source == 4) {
            res.data.data.charge_source = "离线启动";
          } else if (res.data.data.charge_source == 5) {
            res.data.data.charge_source = "其他";
          }

          if (res.data.data.record_source == 2000) {
            res.data.data.record_source = "自动充满";
          } else if (res.data.data.record_source == 2001) {
            res.data.data.record_source = "用户停止";
          } else if (res.data.data.record_source == 2004) {
            res.data.data.record_source = "异常停止";
          }

          if (
            res.data.data.customer_id == "" ||
            res.data.data.customer_id == null
          ) {
            res.data.data.customer_id = "普通用户";
          } else {
            res.data.data.customer_id = "集团客户";
          }

          if (res.data.data.pre_status == 2) {
            res.data.data.pre_status = "已支付";
            this.wwshow = true;
          } else if (res.data.data.pre_status == 3) {
            res.data.data.pre_status = "已退款";
            this.wwshow = true;
          } else if (res.data.data.pre_status == 4) {
            res.data.data.pre_status = "无需退款";
            this.wwshow = true;
          } else if (res.data.data.pre_status == 5) {
            res.data.data.pre_status = "退款失败";
            this.wwshow = true;
          } else if (
            res.data.data.pre_status == 0 ||
            res.data.data.pre_status == "" ||
            res.data.data.pre_status == null||
            res.data.data.pre_status==undefined
          ) {
            this.wwshow = false;
          }

          // 把秒转化成hh:mm:ss
          res.data.data.charge_time = transformStringTime(
            res.data.data.charge_time
          );

          this.stationInfo.push({
            station_name: res.data.data.station_name,
            charger_name: res.data.data.charger_name,
            gun_no: res.data.data.gun_no,
            charge_time: res.data.data.charge_time,
            serv_fee: res.data.data.serv_fee,
            total_power_fee: res.data.data.total_power_fee,
            elce_fee: res.data.data.elce_fee,
            elce_fee_discount: res.data.data.elce_fee_discount,
          });
          this.customInfo.push({
            nickname: res.data.data.nickname,
            customer_id: res.data.data.customer_id,
            jtid: res.data.data.jtid,
            balance: res.data.data.balance,
            openid: res.data.data.openid,
            plate_number: res.data.data.plate_number,
            vin: res.data.data.vin,
          });
          this.payInfo.push({
            start_time: res.data.data.start_time,
            end_time: res.data.data.end_time,
            total_power: res.data.data.total_power,
            freeze_money: res.data.data.freeze_money,
            refund_money: res.data.data.refund_money,
            status: res.data.data.status,
            charge_source: res.data.data.charge_source,
            batch_s: res.data.data.batch_s,
            record_source: res.data.data.record_source,
            pay_type: res.data.data.pay_type,
          });
          this.rateInfo.push({
            start_charge: res.data.data.start_charge,
            end_charge: res.data.data.end_charge,
            power1: res.data.data.power1,
            power2: res.data.data.power2,
            power3: res.data.data.power3,
            power4: res.data.data.power4,
            amount1: res.data.data.amount1,
            amount2: res.data.data.amount2,
            amount3: res.data.data.amount3,
            amount4: res.data.data.amount4,
          });
          this.yufu.push({
            request_num: res.data.data.request_num,
            pre_amount: res.data.data.pre_amount,
            pre_status: res.data.data.pre_status,
            pre_paytime: res.data.data.pre_paytime,
            refund_money: res.data.data.refund_money,
          });
          this.xiaofei.push({
            before_balance: res.data.data.before_balance,
            before_voucher: res.data.data.before_voucher,
            elce_fee_balance: res.data.data.elce_fee_balance,
            elce_fee_voucher: res.data.data.elce_fee_voucher,
            after_balance: res.data.data.after_balance,
            after_voucher: res.data.data.after_voucher,
          })
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.record-time {
  width: 98%;
  margin: 1%;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }

  .el-dialog {
    .el-dialog__header{
      display: none;
    }
    div {
      margin-bottom: 20px;
      text-align: left;
      p {
        display: inline;
        font-size: 18px;
        font-weight: bold;
        color: black;
        margin-bottom: 10px;
      }
    }
  }
}

.topview {
  height: 60px;
  color: #0071bd;
  background-color: white;
  text-align: left;
  span {
    margin-left: 13px;
    line-height: 60px;
    font-weight: bold;
  }
}
.lowerview {
  overflow: hidden;
  clear: both;
  background-color: white;
  margin-top: 10px;
  // padding: 1%;
  // padding-top: 15px;
}
.centerview {
  padding: 1%;
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    float: left;
    margin: 5px 5px 5px 0;
  }
  .allkeyword {
    width: 440px;
  }
}

.querybutton {
  width: 80px;
  height: 35px;
  background-color: #0071bd;
  color: white;
  display: inline-block;
  text-align: center;
  border: none;
  padding: 0;
}
.querybutton:active {
  background-color: #409eff;
}
.record-time {
  .search:active {
    background-color: #409eff;
  }
}
.exportbutton {
  width: 80px;
  height: 35px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
  padding: 0;
}
.exportbutton.active {
  background-color: #a5a5a5;
}
.exportbutton.active:hover {
  background-color: #a5a5a5;
}

.bottomviewtwo {
  padding: 1%;
  margin-top: 15px;
  .btn01 {
    color: #0061ae;
  }
  .btn02 {
    color: #e60000;
  }
  .btn03 {
    color: #009a5b;
  }
  .btn04 {
    color: #e9c15b;
  }
  .btn05 {
    color: #999999;
  }
}

.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
.el-dialog {
  width: 55%;
  min-width: 1000px;
}

h1,
h2 {
  font-weight: normal;
  color: #fff;
}

a {
  color: #42b983;
}

// @media screen and(max-width:1900px) {
//   .record-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 30%;
//         }
//       }
//     }
//   }
// }
// @media screen and(max-width:1460px) {
//   .record-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 40%;
//         }
//       }
//     }
//   }
// }
// @media screen and(max-width:1420px) {
//   .record-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 45%;
//         }
//       }
//     }
//   }
// }
</style>
<style lang="scss">
.record-time {
  .bottomviewtwo {
    .el-table tbody tr:hover > td {
      background-color: #f3f3f3 !important;
      color: black;
    }
  }
  .el-dialog {
    width: 55%;
    min-width: 1000px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/chargeManagement/chargingRecord.vue